import React, { Fragment } from "react";
import { Form, Button, Select, InputNumber, Input, DatePicker } from "antd";
import { ReactSVG } from "react-svg";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchSpinGames } from "../../actions/spinTheWheelGame";

const SpinRewardForm = ({
	handleSubmitForm,
	form,
	handleCancel,
	spinRewardId,
}) => {
	const dispatch = useDispatch();
	const { spinGames, loading } = useSelector((state) => state.fetchSpinGames);
	useEffect(() => {
		dispatch(fetchSpinGames());
	}, []);
	return (
		<Fragment>
			<Form form={form} onFinish={handleSubmitForm} requiredMark={false}>
				<div className="form-content-group">
					<Form.Item
						label="Game"
						name="game_id"
						rules={[{ required: true, message: "Required" }]}
					>
						<Select
							placeholder="Required"
							showSearch
							optionFilterProp="children"
							loading={loading}
						>
							{spinGames &&
								spinGames.data.data.map((item) => (
									<Select.Option key={item.id} value={item.id}>
										{item.name}
									</Select.Option>
								))}
						</Select>
					</Form.Item>
					<Form.Item
						label="Name"
						name="name"
						rules={[{ required: true, message: "Required" }]}
					>
						<Input placeholder="Required" />
					</Form.Item>
					<Form.Item
						label="Identifier"
						name="identifier"
						rules={[{ required: true, message: "Required" }]}
					>
						<Input placeholder="Required" />
					</Form.Item>
					<Form.Item label="Quantity" name="quantity">
						<InputNumber placeholder="Required" style={{ width: "100%" }} />
					</Form.Item>
					<Form.Item label="Start Date" name="start_date">
						<DatePicker format={"DD/MM/YYYY"} style={{ width: "100%" }} />
					</Form.Item>
					<Form.Item label="End Date" name="end_date">
						<DatePicker format={"DD/MM/YYYY"} style={{ width: "100%" }} />
					</Form.Item>
				</div>
				<div className="form-actions">
					<Button type="link" onClick={handleCancel}>
						{" "}
						Cancel{" "}
					</Button>
					<Button type="primary" htmlType="submit" className="btn btn-primary">
						{spinRewardId ? "Update" : "Create"}
						<ReactSVG src="/icons/check-button.svg" />
					</Button>
				</div>
			</Form>
		</Fragment>
	);
};

export default SpinRewardForm;
